import { BehaviorSubject } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { CountryService } from '../../demo/service/countryservice';
import { SelectItem } from 'primeng/api';
import { AcType } from 'src/app/models/ac-type';
import { FilterdataService } from 'src/app/argic/services/filterdata.service';
import { Searchquery } from 'src/app/argic/models/searchquery';
import { Manufacturer } from 'src/app/models/manufacturer';
import { Bodytype, Characteristic, Glassposition, Glasstint, Glasstype, Model } from '../domain/eurocode';
import { LoginService } from 'src/app/login/login.service';
import { take, takeUntil } from 'rxjs/operators';

@Component({
    templateUrl: './matrixsearch-wrapper.component.html',
    styles: [`:host ::ng-deep .p-multiselect {
		min-width: 15rem;
	}

	:host ::ng-deep .multiselect-custom-virtual-scroll .p-multiselect {
		min-width: 20rem;
	}

	:host ::ng-deep .multiselect-custom .p-multiselect-label {
		padding-top: .25rem;
		padding-bottom: .25rem;

	}

	:host ::ng-deep .multiselect-custom .country-item.country-item-value {
		padding: .25rem .5rem;
		border-radius: 3px;
		display: inline-flex;
		margin-right: .5rem;
		background-color: var(--primary-color);
		color: var(--primary-color-text);
	}

	:host ::ng-deep .multiselect-custom .country-item.country-item-value img.flag {
		width: 17px;
	}

	:host ::ng-deep .multiselect-custom .country-item {
		display: flex;
		align-items: center;
	}

	:host ::ng-deep .multiselect-custom .country-item img.flag {
		width: 18px;
		margin-right: .5rem;
	}

	:host ::ng-deep .multiselect-custom .country-placeholder {
		padding: 0.25rem;
	}

	:host ::ng-deep .p-colorpicker {
		width: 2.5em
	}
    `]
})
export class MatrixSearchWrapperComponent implements OnInit, OnDestroy {
    isSelectedTypeAcc: boolean = false;
    isSelectedTypeGlass: boolean = false;

    eurocode: string;
    createdFrom: Date;
    createdTo: Date;
    euroReferenceType: any;
    euroReferenceQuery: string;
    selectedType: string;
    sopMonth: any;
    sopYear: any;
    eopMonth: any;
    eopYear: any;
    countries: any[];

    euroReferences: any[];
    filteredCountries: any[];
    filteredAcTypes: AcType[];
    filteredManufacturers: Manufacturer[];
    filteredModels: Model[];
    filteredCharacteristics: Characteristic[];
    filteredGlasstints: any[];
    filteredGlasspositions: any[];
    filteredGlasstoptints: any[];
    filteredGlasstypes: any[];
    filteredBodytypes: any[];

    selectedCountryAdvanced: any[];
    selectedAcType: any[];
    selectedManufacturer: any[];
    selectedModel: any[];
    selectedCharacteristic: any[];
    selectedBodytype: any[];
    selectedGlassposition: any[];
    selectedGlasstint: any[];
    selectedGlasstoptint: any[];
    selectedGlasstype: any[];

    valSlider = 50;
    valColor = '#424242';
    valRadio: string;
    valCheck: string[] = [];
    valSwitch: boolean;
    cities: SelectItem[];
    selectedList: SelectItem;
    selectedDrop: SelectItem;
    selectedMulti: string[] = [];
    valToggle = false;
    paymentOptions: any[];
    valSelect1: string;
    valSelect2: string;
    valueKnob = 20;

    actypes: AcType[];
    manufacturers: Manufacturer[];
    models: Model[];
    characteristics: Characteristic[];
    bodytypes: Bodytype[];
    glasstypes: Glasstype[];
    glasstints: Glasstint[];
    glasstoptints: Glasstint[];
    glasspositions: Glassposition[];

    sopMonths: any[] = [];
    sopYears: any[] = [];
    eopMonths: any[] = [];
    eopYears: any[] = [];

    //public searchdata = new BehaviorSubject<Searchquery | null>(null);
    readySub = null;
    isReady$ = new BehaviorSubject<boolean>(false);

    constructor(private loginService: LoginService, private countryService: CountryService, private filterdataService: FilterdataService) { }

    ngOnInit() {
        this.readySub = this.loginService.ready$
            .pipe(take(2)) //first false, then true
            .subscribe((isReady) => {
            if (isReady) {
                // let searchQuery = new Searchquery();
                // searchQuery.language = this.loginService.userprofile.languageId;
                // searchQuery.userid = this.loginService.userprofile.userid;
                // searchQuery.login = this.loginService.userprofile.login;
                // this.searchdata.next(searchQuery);
                this.isReady$.next(true);
            }
        });
    }

    ngOnDestroy(): void {
        if (this.readySub) this.readySub.unsubscribe();
    }

    // filterCountry(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;
    //     for (let i = 0; i < this.countries.length; i++) {
    //         const country = this.countries[i];
    //         if (country.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
    //             filtered.push(country);
    //         }
    //     }

    //     this.filteredCountries = filtered;
    // }

    // onManuChange() {
    //     this.filterModels({ query: '' });
    // }

    // onChangeGlasstype() {
    //     this.filterCharacteristics({ query: '' });
    // }

    // filterAcTypes(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;
    //     this.actypes.forEach(e => {
    //         if (e.acType_En.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //         else if (e.acType.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //     });
    //     this.filteredAcTypes = filtered;
    // }

    // filterGlasstypes(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;
    //     this.glasstypes.forEach(e => {
    //         if (e.description.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //         else if (e.description.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //     });
    //     this.filteredGlasstypes = filtered;
    // }

    // filterManufacturers(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;
    //     if (this.manufacturers)
    //         this.manufacturers.forEach(e => {
    //             if (e.description.toLowerCase().includes(query.toLowerCase())) filtered.push(e);
    //         });
    //     this.filteredManufacturers = filtered;
    // }

    // filterModels(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;
    //     if (this.selectedManufacturer == null) { this.filteredModels = []; return }
    //     let searchdata = { mancodes: this.selectedManufacturer['manCodes'] };
    //     this.filterdataService.getModelsQuery(searchdata).subscribe(
    //         d => {
    //             let langid = this.loginService.userprofile.languageId;
    //             let langfield;
    //             switch (langid) {
    //                 case 1: langfield = "mod_En"; break;
    //                 case 2: langfield = "mod_De"; break;
    //                 case 3: langfield = "mod_Fr"; break;
    //                 case 4: langfield = "mod_It"; break;
    //                 case 5: langfield = "mod_Es"; break;
    //                 case 6: langfield = "mod_Nl"; break;
    //             }
    //             var d2 = d.map(e => { return { ...e, description: e[langfield] } });
    //             this.models = d2
    //             this.models.forEach(e => { if (e.description != null && e.description.toLowerCase().includes(query.toLowerCase())) filtered.push(e); });
    //             this.filteredModels = filtered;
    //         }
    //     );
    // }

    // filterTopTints(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;
    //     this.glasstoptints.forEach(e => {
    //         if (e.glassTint_En.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //         else if (e.glassTint_En.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //     });
    //     this.filteredGlasstoptints = filtered;
    // }

    // filterTints(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;
    //     this.glasstints.forEach(e => {
    //         if (e.glassTint_En.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //         else if (e.glassTint_En.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //     });
    //     this.filteredGlasstints = filtered;
    // }

    // filterBodytypes(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;
    //     this.bodytypes.forEach(e => {
    //         if (e.bodyType_En.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //         else if (e.bodyType_En.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //     });
    //     this.filteredBodytypes = filtered;
    // }

    // filterGlasspositions(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;
    //     this.glasspositions.forEach(e => {
    //         if (e.glassposition_En.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //         else if (e.glassposition_En.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //     });
    //     this.filteredGlasspositions = filtered;
    // }

    // filterCharacteristics(event) {
    //     const filtered: any[] = [];
    //     const query = event.query;

    //     if (this.selectedGlasstype == null) {
    //         this.characteristics.forEach(e => {
    //             if (e.en.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //             else if (e.en.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //         });
    //     } else {
    //         let gt = this.selectedGlasstype['glassTypeId'];
    //         this.characteristics.forEach(e => {
    //             if (e.glassTypeID !== gt) return;
    //             if (e.en.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //             else if (e.en.toLowerCase().indexOf(query.toLowerCase()) == 0) filtered.push(e);
    //         });
    //     }
    //     this.filteredCharacteristics = filtered;
    // }

    // doSearch() {
    //     let searchQuery = new Searchquery();

    //     searchQuery.language = this.loginService.userprofile.languageId;
    //     searchQuery.userid = this.loginService.userprofile.userid;
    //     searchQuery.login = this.loginService.userprofile.login;

    //     if (this.eurocode && this.eurocode.length > 0) {
    //         searchQuery.textquery = this.eurocode.replace("%", "*");
    //     }
    //     if (this.createdFrom) searchQuery.createdfrom = this.createdFrom;
    //     if (this.createdTo) searchQuery.createdto = this.createdTo;
    //     if (this.selectedType) searchQuery.selectedtype = this.selectedType;
    //     if (this.euroReferenceType) searchQuery.euroreferencetype = this.euroReferenceType.value;
    //     if (this.euroReferenceQuery) searchQuery.euroreferencequery = this.euroReferenceQuery;
    //     if (this.sopYear) searchQuery.sopyear = this.sopYear.value;
    //     if (this.sopMonth) searchQuery.sopmonth = this.sopMonth.value;
    //     if (this.eopYear) searchQuery.eopyear = this.eopYear.value;
    //     if (this.eopMonth) searchQuery.eopmonth = this.eopMonth.value;

    //     if (this.selectedManufacturer) searchQuery.mancodes = this.selectedManufacturer['manCodes'];
    //     if (this.selectedGlasstype) searchQuery.matrixtypeid = this.selectedGlasstype['matrixTypeId'];
    //     if (this.selectedGlasstype) searchQuery.glasstypeid = this.selectedGlasstype['glassTypeId'];
    //     if (this.selectedModel) searchQuery.modid = this.selectedModel['modId'];
    //     if (this.selectedCharacteristic) {
    //         var chars = "";
    //         this.selectedCharacteristic.forEach(element => {
    //             chars += element['charID'];
    //         });
    //         searchQuery.charid = chars;
    //     }

    //     if (this.selectedGlasstint) searchQuery.glasstintid = this.selectedGlasstint['glassTint'];
    //     if (this.selectedGlasstoptint) searchQuery.glasstoptintid = this.selectedGlasstoptint['glassTint'];
    //     if (this.selectedBodytype) searchQuery.bodytypeid = this.selectedBodytype['bodyType'];
    //     if (this.selectedGlassposition) searchQuery.glasspositionid = this.selectedGlassposition['glassposition'];
    //     if (this.selectedAcType) searchQuery.actypeid = this.selectedAcType['acType'];

    //     this.searchdata.next(searchQuery);
    // }
    // flatten(arr: string[]) {
    //     return arr.join(",");
    // }

    // doReset() {
    //     this.eurocode = null;
    //     this.createdFrom = null;
    //     this.createdTo = null;
    //     this.selectedType = null;
    //     this.selectedManufacturer = null;
    //     this.selectedGlasstoptint = null;
    //     this.selectedGlasstype = null;
    //     this.selectedModel = null;
    //     this.selectedGlasstint = null;
    //     this.selectedGlassposition = null;
    //     this.selectedCharacteristic = null;
    //     this.selectedBodytype = null;
    //     this.selectedAcType = null;
    //     this.euroReferenceType = null;
    //     this.euroReferenceQuery = null;
    //     this.sopYear = null;
    //     this.sopMonth = null;
    //     this.eopYear = null;
    //     this.eopMonth = null;
    //     //this.searchdata.next(new Searchquery());
    // }

    // onSelectedTypeClick() {
    //     this.isSelectedTypeAcc = false;
    //     this.isSelectedTypeGlass = false;

    //     if (this.selectedType == 'glass') {
    //         this.isSelectedTypeGlass = true;
    //     }
    //     else if (this.selectedType == 'acc') {
    //         this.isSelectedTypeAcc = true;
    //     }
    // }
}
